export default __webpack_public_path__ + "static/media/AvatarKids-18.f1bc6c92.png";